import {DetailTable} from '../../../mapping-classes/detail-table';

export class Volmacht implements DetailTable {
  restrictedData;
  shieldedText;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(objects: any) {
    if (!objects || objects.length === 0) {
      this.createErrorMessage();
    } else {
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(objects);
    }
  }

  createErrorMessage() {
    this.errorText = 'Deze volmacht heeft geen producten.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'bankAccountNumber',
      'name',
      'lifeCycleStatus',
      'authorizations',
    ];
  }

  setRowData(objects) {
    objects.forEach((object) => {
      this.rowData.push(object);
    });
  }

}
